module.exports = __webpack_public_path__ + "static/media/brutal.20fad02b.png";